export default "__VITE_ASSET__BGCP$Z2S__"